"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var GraphQLClient_1 = tslib_1.__importDefault(require("./GraphQLClient"));
exports.default = GraphQLClient_1.default;
//# sourceMappingURL=index.js.map